export default {
    parameters: {
        landing_id: "TrQWeb",
        segment: 39
    },
    startPage: {
      title: "Çocuğunuzla birlikte geleceğe hazırlanmaya şimdiden başlayın!",
      button: "Webinar’da yerinizi ayırtın",
      imageMobile: {
        url: "/welcome/quiz_turkey_webinar_mobile.png",
        style: {
          width: "100%",
        },
      },
      image: {
        url:  "/welcome/quiz_turkey_webinar_pk.png",
        style: {
            height: "100%",
            "max-height": "100vh",
        },
      },
    },
    quizRotateBySteps: {
      1: {
        question: "Çocuğunuzun hangi becerileri geliştirmesini istiyorsunuz?",
        answers: [
          "🎨 Web tasarımı",
          "🖼 Animazyon Çizmek",
          "🌐 Kodlama Becerileri",
          "🎮 Bilgisayar Oyunları Oluşturmak",
          "➗ Matematik",
        ],
      },
      2: {
        title: "Webinar 2 Mayıs akşam 8'de gerçekleşecektir.",
        type: "timeslot",
        subtitle:
          "Eğer o saatte müsait iseniz, lütfen aşağıdaki butona tıklayınız.",
        button: "Rezervasyon için tıklayın 🎁",
      },
      3: {
        title: "Çocuğunuz kaç yaşında?",
        type: "age",
        subtitle: "Lütfen çocuğunuzun doldurduğu yaşı seçin.",
        button: "İleri 🚀",
      },
      4: {
        title: "Çocuğunuzun adı nedir?",
        type: "child_name",
        subtitle: "Veriler korunmaktadır ve talebiniz üzerine silinecektir 🚨",
        button: "İleri 🚀",
      },
      5: {
        title: "E-postanızı girin",
        type: "mail",
        subtitle: "Endişelenmeyin, spam gönderilmeyecek😅",
        button: "İleri 🚀",
      },
      6: {
        title: "Telefon numaranızı girin",
        type: "phone",
        subtitle: "Önemli konularda sizinle iletişime geçmek için kullanacağız 📞",
        button: "Neredeyse bitti 🔥",
      },
      7: {
        title: "İsminizi girin",
        type: "parent_name",
        subtitle: "Bizim adımız Kodland, sizinki ne?👋",
        button: "Son adım! 🎉",
      },
    },
  };
  
  